import { useRef, useState } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import {
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerWrapper,
} from 'approot/activity-builder/activity-builder-drawer';
import { FileDropperContextProvider } from 'lib/form/file-dropper/file-dropper.context';
import InteractiveResponseItems from './interactive-response-items';
import InteractiveResponseSolution from './interactive-response-solution';
import { InteractiveResponseDetailsForm } from './interactive-response-details';
import Tabs from 'approot/shared/tabs/tabs';
import { useSortableScrollManager } from 'approot/shared/sortable/sortable.hooks';
import { SORTABLE_CARD } from 'approot/shared/sortable/sortable.constants';
import { SettingProps } from './interactive-response.constants';
import * as Styled from './interactive-response-settings.style';

type Props = SettingProps & {
  onCloseChildDrawer?: () => void;
};

const InteractiveResponseSettingsContent = (props: Props) => {
  const { onCloseChildDrawer } = props;
  const { closeDrawer } = useActivityBuilderContext();
  const ref = useRef<HTMLDivElement | null>(null);

  const [tab, setTab] = useState<number>(3);

  useSortableScrollManager(ref, [SORTABLE_CARD]);

  const onClose = onCloseChildDrawer ? onCloseChildDrawer : closeDrawer;
  return (
    <ActivityBuilderDrawerWrapper onCloseByEscape={onClose}>
      <ActivityBuilderDrawerHeader
        title="Matching or Sequencing"
        isBack={!!onCloseChildDrawer}
        onClose={onClose}
      />
      <Styled.InteractiveResponseTabs>
        <Tabs
          ariaDescription="Interactive edit setting tab options"
          contentPanelId="content"
          options={[
            { label: 'Details', value: 3 },
            { label: 'Content', value: 1 },
            { label: 'Solution', value: 2 },
          ]}
          activeTab={tab}
          onSelect={tab => setTab(tab.value as number)}
        />
      </Styled.InteractiveResponseTabs>

      <ActivityBuilderDrawerContent ref={ref}>
        <div id="content" tabIndex={-1}>
          {tab === 1 && <InteractiveResponseItems {...props} />}
          {tab === 2 && <InteractiveResponseSolution {...props} />}
          {tab === 3 && <InteractiveResponseDetailsForm {...props} />}
        </div>
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

const InteractiveResponseSettings = (props: Props) => (
  <FileDropperContextProvider>
    <InteractiveResponseSettingsContent {...props} />
  </FileDropperContextProvider>
);

export default InteractiveResponseSettings;
